import axios from 'axios';

import { API } from '@/config/constants';


export const getCommunities = async (config) => {
  const response = await axios.get(`${API}/communities`, ...config ? [config] : []);
  return response.data;
};

export const getCommunity = async (communityId, config) => {
  const response = await axios.get(`${API}/communities/${communityId}`, ...config ? [config] : []);
  return response.data;
};

export const createCommunity = async (data, config) => {
  const response = await axios.post(`${API}/communities`, data, ...config ? [config] : []);
  return response.data;
};

export const updateCommunity = async (communityId, data, config) => {
  const response = await axios.patch(`${API}/communities/${communityId}`, data, ...config ? [config] : []);
  return response.data;
};

export const deleteCommunity = async (communityId, config) => {
  const response = await axios.delete(`${API}/communities/${communityId}`, ...config ? [config] : []);
  return response.data;
};

export const addCommunityAddress = async (communityId, data, config) => {
  const response = await axios.post(`${API}/communities/${communityId}/addresses`, data, ...config ? [config] : []);
  return response.data;
};

export const deleteCommunityAddress = async (communityId, placeId, config) => {
  const response = await axios.delete(
    `${API}/communities/${communityId}/addresses/${encodeURIComponent(placeId)}`,
    ...config ? [config] : [],
  );
  return response.data;
};
